import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  previewImage?: string;
}
export function Accordion({
  title,
  children,
  isOpen = false,
  previewImage
}: AccordionProps) {
  const [open, setOpen] = useState(isOpen);
  return <div className="border border-gray-200 bg-white rounded-lg mb-3 overflow-hidden shadow-sm" data-id="element-162" data-mp="28drqhkml8oyj">
      {previewImage && <div className="relative w-full h-32 md:h-40 overflow-hidden" data-id="element-163" data-mp="2n5s9qz0j1xzb">
          <img src={previewImage} alt="" aria-hidden="true" className="w-full h-full object-cover object-top" data-id="element-164" data-mp="2i4meatfhfwm3" />
          {/* Gradient fade into the card */}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/20 to-white" data-id="element-165" data-mp="2s0xqljf2omgj" />
        </div>}
      <button className="w-full px-4 py-4 flex justify-between items-center text-left focus:outline-none" onClick={() => setOpen(!open)} data-id="element-166" data-mp="xpanzapxvhpl">
        <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-167" data-mp="3g5x62dj6jj62">
          {title}
        </span>
        {open ? <ChevronUp className="w-5 h-5 text-green-700 flex-shrink-0" data-id="element-168" data-mp="3l0ufhlkdfujh" /> : <ChevronDown className="w-5 h-5 text-green-700 flex-shrink-0" data-id="element-169" data-mp="3q06yfv84ghgs" />}
      </button>
      {open && <div className="px-4 pb-4 text-gray-600 text-sm md:text-base whitespace-pre-line border-t border-gray-100 pt-3" data-id="element-170" data-mp="3mp956wzzpb1">
          {children}
        </div>}
    </div>;
}